<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="152" height="106" viewBox="0 0 152 106" fill="none">
    <path
      d="M125.055 50.8879V11.2076C125.055 5.60676 120.514 1.06641 114.914 1.06641H11.2076C5.60676 1.06641 1.06641 5.60676 1.06641 11.2076V76.3503C1.06641 81.9511 5.60677 86.4914 11.2076 86.4914H114.914C120.514 86.4914 125.055 81.9511 125.055 76.3503V58.0262"
      stroke="#E2E4E8"
      stroke-width="2.1327"
      stroke-linecap="round"
    />
    <path d="M1.79883 15.6914H125.055" stroke="#E2E4E8" stroke-width="2.1327" />
    <circle cx="10.8287" cy="9.50349" r="1.46443" fill="#293D66" />
    <circle cx="17.9078" cy="9.50349" r="1.46443" fill="#293D66" />
    <circle cx="24.7418" cy="9.50349" r="1.46443" fill="#293D66" />
    <path d="M48.9844 57.1912H76.9535V54.2832H48.9844V57.1912Z" fill="#FF531A" />
    <path
      d="M71.1832 47.3025L66.1238 41.9672L61.1693 47.2274L56.1369 41.9702L48.6963 49.7598L51.2155 52.4094L56.1369 47.1313L61.1693 52.4004V52.4094L66.1268 47.1252L71.1862 52.3944V52.4094L82.8195 40.8798L80.3303 38.2031L71.1832 47.3025Z"
      fill="#FF531A"
    />
    <path
      opacity="0.3"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M56.1092 47.094L51.1912 52.3457L48.6963 49.6966L53.6426 44.5205L56.1092 47.094Z"
      fill="url(#paint0_linear_11146_13242)"
    />
    <path
      opacity="0.3"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M66.1373 47.1049L61.1706 52.3662L58.75 49.7871L63.724 44.5205L66.1373 47.1049Z"
      fill="url(#paint1_linear_11146_13242)"
    />
    <path
      d="M97.2488 58.1458C96.9712 58.4234 96.9712 58.8735 97.2488 59.1511L101.773 63.6753C102.051 63.9529 102.501 63.9529 102.778 63.6753C103.056 63.3976 103.056 62.9475 102.778 62.6699L98.7568 58.6484L102.778 54.627C103.056 54.3494 103.056 53.8992 102.778 53.6216C102.501 53.344 102.051 53.344 101.773 53.6216L97.2488 58.1458ZM127.963 104.857V104.146H65.0479V104.857V105.568H127.963V104.857ZM97.7515 58.6484V59.3593H127.963V58.6484V57.9375H97.7515V58.6484ZM151.067 81.7527H150.356C150.356 94.1202 140.33 104.146 127.963 104.146V104.857V105.568C141.115 105.568 151.778 94.9055 151.778 81.7527H151.067ZM151.067 81.7527H151.778C151.778 68.5999 141.115 57.9375 127.963 57.9375V58.6484V59.3593C140.33 59.3593 150.356 69.3852 150.356 81.7527H151.067Z"
      fill="#293D66"
    />
    <defs>
      <linearGradient
        id="paint0_linear_11146_13242"
        x1="48.6963"
        y1="44.5205"
        x2="48.6963"
        y2="52.3457"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="1" stop-color="#D8D8D8" stop-opacity="0.01" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_11146_13242"
        x1="58.75"
        y1="44.5205"
        x2="58.75"
        y2="52.3662"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="1" stop-color="#D8D8D8" stop-opacity="0.01" />
      </linearGradient>
    </defs>
  </svg>
</template>
